export function toInitials(words: string[]) {
  return words.map((word) => word.charAt(0)).join('');
}
